<template>
    <div>
        <div class="row">
            <div class="col-5">
                <b-breadcrumb>
                    <b-breadcrumb-item :to="{name: 'page-list'}">
                        Page List
                    </b-breadcrumb-item>
                    <b-breadcrumb-item :to="{name: 'page-editor'}">
                        {{page.key}}
                    </b-breadcrumb-item>
                    <b-breadcrumb-item active>blocks</b-breadcrumb-item>
                </b-breadcrumb>
            </div>
        </div>

        <div class="row" v-if="stateOptions && stateOptions.length">

            <!-- State Select -->
<!--            TODO: if the page has a specific state, lock that state here as well.-->
            <div class="col-6 form-group">
<!--                {{stateBlockCount}}-->
<!--                {{stateOptions}}-->
                <div>State:</div>
                <multiselect id="state"
                             v-model="blockState"
                             :options="stateOptions"
                             label="label"
                             track-by="state"
                             placeholder="State"
                             :searchable="true"
                             :multiple="false"
                             class="mb-2"
                />
                <b-button v-b-toggle.sidebar-block-count variant="link">View State Block Count</b-button>
                <b-sidebar id="sidebar-block-count" title="Blocks" shadow>
                    <h3>State Block Count</h3>
                    <div class="px-3 py-2">
                        <b-table-simple striped>
                            <b-thead>
                                <b-tr>
                                    <b-th>State</b-th>
                                    <b-th>Count</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="stateCount in stateBlockCount" :key="`sidebar_${stateCount.state}`">
                                    <b-td>{{stateCount.state}}</b-td>
                                    <b-td>{{stateCount.state_count}}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-sidebar>
<!--                <b-select class="form-control" v-model="state" @change="getStateData">-->
<!--                    <option value="DEFAULT">Default</option>-->
<!--                    <option v-for="(state, i) in states" :key="state.state" :value="state.state">-->
<!--                        {{state.fullState}} <template v-if="stateBlockCount[state.state]"> {{ stateBlockCount[state.state].state_count }}</template>-->
<!--                    </option>-->
<!--                </b-select>-->
            </div>

            <!-- Save Buttons -->
            <div class="col-6 pr-5">
                <div class="row d-flex justify-content-end">
<!--                    <b-btn class="border-dark" variant="light">-->
<!--                        <font-awesome-icon :icon="['fal', 'eye']"></font-awesome-icon> Preview-->
<!--                    </b-btn>-->
                    <b-btn class="ml-3 border-dark" variant="primary" @click="saveBlocks(false)">
                        <font-awesome-icon :icon="['fal', 'save']"></font-awesome-icon> Save All & Publish
                    </b-btn>
                </div>
                <div class="row mt-3 d-flex justify-content-end">
<!--                    <b-checkbox v-model="homeschool" @change="toggleHomeschool()">Homeschool Store</b-checkbox>-->
                </div>
            </div>
        </div>

        <StateProductBlock v-if="sn_blocks" :messages.sync="messages" :blocks.sync="blocks" page="science" @remove="removeBlock" />

        <!-- Footer Btns -->
        <div class="mt-3">
            <div class="d-inline float-left">
                <b-dropdown text="Add a Block">
                    <b-dropdown-item @click="addBlock('static')">
                        HTML Page
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock('html')">
                        HTML Editor
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock('raw')">
                        Text Editor
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock('double_column')">
                        2 Column Text Editor
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock('flipbook')">
                        Flip Book
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock('standards')">
                        Standards & Correlations
                    </b-dropdown-item>
<!--                    <b-dropdown-item @click="addBlock('teacher_materials')">-->
<!--                        Teacher Materials-->
<!--                    </b-dropdown-item>-->
<!--                    <b-dropdown-item @click="addBlock('student_materials')">-->
<!--                        Student Materials-->
<!--                    </b-dropdown-item><b-dropdown-item @click="addBlock('online')">-->
<!--                        SWO-->
<!--                    </b-dropdown-item>-->
                    <!--                    <b-dropdown-item @click="addBlock('national_materials')">-->
                    <!--                        National Materials-->
                    <!--                    </b-dropdown-item>-->
                    <b-dropdown-item @click="addBlock('wyg')">
                        What You Get / Key Features
                    </b-dropdown-item>
                    <!--                    <b-dropdown-item @click="addBlock('online')">-->
                    <!--                        Studies Weekly Online-->
                    <!--                    </b-dropdown-item>-->
                    <!--                                    <b-dropdown-item @click="addBlock('flip')">-->
                    <!--                                        Flip Book-->
                    <!--                                    </b-dropdown-item>-->
                </b-dropdown>
            </div>
            <div class="d-inline float-right">
                <b-button @click="saveBlocks(true)" variant="primary" :disabled="saving">
                    <template v-if="saving">
                        <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                    </template>
                    <template v-else>
                        Save Changes
                    </template>
                </b-button>
            </div>
        </div>
    </div>
</template>


<script>




import {states, publicationStates} from '@/common/states'

import RawBuilder from '@/components/dashboard/storeadmin/blocks/Raw'
import WYGBuilder from '@/components/dashboard/storeadmin/blocks/WhatYouGet'
import TeacherMaterialsBuilder from '@/components/dashboard/storeadmin/blocks/TeacherMaterials'
import StudentMaterialsBuilder from '@/components/dashboard/storeadmin/blocks/StudentMaterials'
import NationalMaterialsBuilder from '@/components/dashboard/storeadmin/blocks/NationalMaterials'
import OnlineBuilder from '@/components/dashboard/storeadmin/blocks/Online'
import ScienceBlurbBuilder from '@/components/dashboard/storeadmin/blocks/ScienceBlurb'
import SSLandingBuilder from '@/components/dashboard/storeadmin/blocks/SSLanding'
import TipTapEditor from "@/components/tiptap/TipTapEditor";
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
import FlipBook from "@/components/dashboard/storeadmin/blocks/FlipBook";
import StateProductBlock from "@/components/dashboard/storeadmin/StateProductBlock";
import {mapGetters, mapState} from "vuex";

export default {
    name: 'store-admin',
    props: ['id'],
    data: () => ({
        html: '',
        blocks: [],
        stateBlockCount: {},
        stateOptions: [],
        currentTab: null,
        sn_blocks: [],
        homeschool: false,
        messages: {},
        states: publicationStates,
        navMessage: null,
        state: "DEFAULT",
        blockState: null,
        product_bg: null,
        saving: false,
        loadingStateData: false
    }),
    components: {
        StateProductBlock,
        FlipBook,
        EditorBlock,
        TipTapEditor,
        RawBuilder,
        WYGBuilder,
        TeacherMaterialsBuilder,
        StudentMaterialsBuilder,
        NationalMaterialsBuilder,
        OnlineBuilder,
        ScienceBlurbBuilder,
        SSLandingBuilder
    },
    computed: {
        ...mapState({
            pages: state => state.stateData.pages,
            stateData: state => state.stateData.stateData,
            selectedState: state => state.stateData.selectedState,
        }),
        page() {
            for (let i = 0; i < this.pages.length; ++i) {
                if (this.pages[i].id != this.id) continue;

                return this.pages[i];
            }
        }
    },
    watch: {
        blockState(value) {
            this.state = value.state;
            this.$nextTick(() => {
                this.getStateData();
            });
        }
    },
    methods: {
        // Blocks
        getStateData () {
            this.loadingStateData = true

            let state
            if (this.state) {
                state = this.state
            } else {
                state = 'DEFAULT'
            }
            let params = {
                state: state,
                pageId: this.page.id,
                draft: 0,
                homeschool: this.homeschool ? 1 : 0
            };

            this.blocks = [];
            this.$store.dispatch('getPageBlocks', params)
                .then((blocks) => {
                    // If a blocks state is DEFAULT, but we're viewing a specific state, clone it, and remove the ID for editing
                    if (this.blockState.state !== 'DEFAULT') {
                        blocks = blocks.map(block => {
                            if (block.state === 'DEFAULT') {
                                let newBlock = Object.assign({}, block);
                                newBlock.id = null;
                                console.log('Cloning DEFAULT block for state ', this.state, newBlock);
                                return newBlock;
                            }
                            return block;
                        });
                    }
                    this.blocks = blocks;
                }).finally(() => {
                    this.loadingStateData = false
            });
        },
        addBlock (type) {
            switch(type) {
                case "html":
                    this.blocks.push({store: null, ordinal: this.blocks.length, type: 'html', value: "<section>placeholder</section>"});
                    break;
                case "flipbook":
                    this.blocks.push({store: null, ordinal: this.blocks.length, type: 'flipbook', title: "", books: [{image: "", id: null, label: ""}]});
                    break;
                case "raw":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'raw', value: 'placeholder' })
                    break;
                case "double_column":
                    this.blocks.push({store: null, ordinal: this.blocks.length, type: 'double_column', value: ["placeholder1", "placeholder2"]})
                    break;
                case "wyg":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'wyg', wyg: [], kf: [], button_label: '', button_uri: '' })
                    break;
                case "national_materials":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'national_materials'})
                    break;
                case "teacher_materials":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'teacher_materials'})
                    break;
                case "student_materials":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'student_materials'})
                    break;
                case "online":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'online'})
                    break;
                case "science_blurb":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'science_blurb'})
                    break;
                case "ss_landing":
                    this.blocks.push({store: null, ordinal: this.blocks.length,  type: 'ss_landing', bgImage: '//cdn.studiesweekly.com/store/Blog-Header-19-640x335.png'})
                    break;
                case "flip":
                    this.blocks.push({store: null, ordinal: this.blocks.length, type: 'flip', books: []});
                    break;
                case "static":
                    this.blocks.push(({store:null, ordinal: this.blocks.length, type: 'static', src:''}));
                    break;
                case "standards":
                    this.blocks.push(({store:null, ordinal: this.blocks.length, type: 'standards'}));
                    break;
            }
        },
        removeBlock (index, target) {
            console.log(this.blocks);
            this.$swal({
                text: `Are you sure you want to delete this block? index: ${index}, type: '${this.blocks[index].type}'`,
                showCancelButton: true,
                confirmButtonText: 'Delete Block',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-light',
                buttonsStyling: false
            }).then((result) => {
                if (result.value) {
                    this.blocks.splice(index, 1)
                }
                console.log(this.blocks);
                this.$forceUpdate();
            })
        },
        saveBlocks (saveAsDraft) {
            this.saving = true

            let data = {
                page_id: this.page.id,
                blocks: this.blocks,
                state: this.state,
                store: this.homeschool ? 'homeschool' : null,
                version: saveAsDraft ? 'draft' : 'published',
            }
            this.$store.dispatch('saveAllBlocks', data)
                .then(() => {
                    this.$swal({
                        toast: true,
                        html: 'Changes saved',
                        type: 'success',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    })
                    this.getStateData();
                })
                .catch((e) => {
                    this.$swal({
                        toast: true,
                        html: 'Something went wrong',
                        type: 'danger',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    })
                    console.log(e);
                })
                .finally(() => {
                    this.saving = false
                });
        },
        toggleHomeschool() {
            this.$store.dispatch('setAsHomeschoolStore', this.homeschool)
                .then(() => {
                    this.getStateData();
                })
        },
        getStateBlockCount() {
            this.axios.get(`pages/content/${this.page.id}/counts`)
                .then(response => {
                    this.stateBlockCount = _.keyBy(response.data, 'state');
                    let defaultState = {state:'DEFAULT', fullState: 'Default'};
                    this.stateOptions = [defaultState, ...this.states];

                    for (let i = 0; i < this.stateOptions.length; ++i) {
                        if (!this.stateBlockCount[this.stateOptions[i].state]) {
                            this.stateOptions[i].label = this.stateOptions[i].fullState;
                            continue;
                        }

                        let count = this.stateBlockCount[this.stateOptions[i].state].state_count;
                        this.stateOptions[i].label = `${this.stateOptions[i].fullState} - ${count} Block(s)`;
                    }
                    this.$nextTick(() => {
                        this.blockState = defaultState;
                    })
                })
        }
    },
    created() {
        this.homeschool = this.$store.getters.isHomeschoolStore;
        this.getStateBlockCount();
    },
    deactivated() {
        document.getElementById('dashboard_nav').classList.remove('d-none');
    },
    mounted () {
        document.getElementById('dashboard_nav').classList.add('d-none');
    }
}
</script>


<style>

#dashboard_content {
    width: 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
}
.block + .block {
    margin-top: 1.5rem;
}
.block .delete {
    position: absolute;
    right: -15px;
    top: -15px;
    border-radius: 100%;
    border: 0;
    padding: 3px 10px;
    z-index: 10;
}

.block .moveup {
    position: absolute;
    right: -15px;
    top: -15px;
    border-radius: 100%;
    border: 0;
    padding: 3px 10px;
    z-index: 10;
}
.block .movedown {
    position: absolute;
    right: -15px;
    top: -15px;
    border-radius: 100%;
    border: 0;
    padding: 3px 10px;
    z-index: 10;
}

/*PAGE STYLING: TODO: remove*/
.callout-pin {
    position: absolute;
    color: red;
    width: 35px !important;
    height: 35px;
}
</style>